import { describe, expect, it } from '@jest/globals';
import type { CloudpackConfig } from '@ms-cloudpack/common-types';
import { ensureGeneratedSettingsForPackage } from './ensureGeneratedSettingsForPackage.js';
import { MockPackageDefinitions } from '@ms-cloudpack/package-utilities';

describe('ensureGeneratedSettingsForPackage', () => {
  it('sets a generated package setting without version for internal', async () => {
    const config: Pick<CloudpackConfig, 'generated'> = { generated: {} };
    const packagePath = '/path/to/package';
    const packages = new MockPackageDefinitions({
      fixture: {
        // The package paths have to be slashed for the package definitions cache.
        [packagePath]: { name: 'test', version: '1.0.0' },
      },
    });
    const generatedPackageSettings = await ensureGeneratedSettingsForPackage({ packagePath }, { config, packages });
    expect(generatedPackageSettings).toEqual({
      match: 'test',
    });
    expect(config.generated.packageSettings).toEqual([generatedPackageSettings]);
  });

  it('sets a generated package setting with `^version` for external', async () => {
    const config: Pick<CloudpackConfig, 'generated'> = { generated: {} };
    const packagePath = '/node_modules/path/to/package';
    const packages = new MockPackageDefinitions({
      fixture: {
        // The package paths have to be slashed for the package definitions cache.
        [packagePath]: { name: 'test', version: '1.0.0' },
      },
    });
    const generatedPackageSettings = await ensureGeneratedSettingsForPackage({ packagePath }, { config, packages });
    expect(generatedPackageSettings).toEqual({
      match: {
        name: 'test',
        version: '^1.0.0',
      },
    });
    expect(config.generated.packageSettings).toEqual([generatedPackageSettings]);
  });

  it('returns first generated package setting if available', async () => {
    const config: Pick<CloudpackConfig, 'generated'> = {
      generated: {
        packageSettings: [
          {
            match: {
              name: 'test',
              version: '^1.0.0',
            },
            exports: {
              './foo': './foo.js',
            },
          },
          {
            match: {
              name: 'test',
              version: '^1.0.0',
            },
            exports: {
              './bar': './bar.js',
            },
          },
        ],
      },
    };
    const packagePath = '/node_modules/path/to/package';
    const packages = new MockPackageDefinitions({
      fixture: {
        // The package paths have to be slashed for the package definitions cache.
        [packagePath]: { name: 'test', version: '1.1.5' },
      },
    });
    const generatedPackageSettings = await ensureGeneratedSettingsForPackage({ packagePath }, { config, packages });
    expect(generatedPackageSettings).toEqual({
      match: {
        name: 'test',
        version: '^1.0.0',
      },
      exports: {
        './foo': './foo.js',
      },
    });
  });
});
